import { WorkflowplanAppointment } from "./WorkflowplanAppointment";

export class Workflowplan
{
  constructor(
    public id?: string,
    public catalogId?: string,
    public workflowId?: string,
    public appointment?: WorkflowplanAppointment,
    public lastRun?: Date,
    public executionCounter?: number,
    public timesFailed?: number,
    public active: boolean = true,
  ) {
  }
}
